import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useToast } from '../hooks/useToast';
import Toast from './Toast';
import './Footer.css';

function Footer() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const { toast, showToast, closeToast } = useToast();

  const handleSubscribe = async (e) => {
    e.preventDefault();

    if (!email) {
      showToast('Please enter your email address', 'warning');
      return;
    }

    setSubmitting(true);

    try {
      const response = await axios.post('/api/newsletter/subscribe', { email });
      showToast(response.data.message, 'success');
      setEmail(''); // Clear input on success
    } catch (error) {
      showToast(error.response?.data?.error || 'Failed to subscribe. Please try again.', 'error');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="footer">
      {toast && <Toast message={toast.message} type={toast.type} onClose={closeToast} />}
      <div className="footer-border">
        <svg enableBackground="new 0 267.6 960 7.1" viewBox="0 267.6 960 7.1" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <path className="elementor-shape-fill" fill="#292929" d="m168.3 270.6c.3-.7.1-1 .4-1.7-.5 0-.8-.3-1.4-.1-.4 1-.2 1.7 1 1.8zm465.9 0c.3-.7 0-1 .4-1.7-.5 0-.8-.3-1.5-.1-.3 1-.2 1.7 1.1 1.8zm296.9 3c-.5-.1-1-.1-1.5-.2-3.1-.3-5 .2-5.7-1.7-3.3-.5-6.5.9-9.6.5-.7.2-1 .6-1.8.8-2.2-1.2-4.8-.3-7.3-.3-3.3 0-4.8-2.2-7.3-2.3-.3.2-.3.7-1 .6-2.5-.5-4.3.6-6.5.4-1.8-.1-2.8-1.3-4.5-1.8-3.3-.1-7.5-.1-10.5-.5-2-.3-4.3-1.4-5.6-1.5-1-.1-2.5 0-3.3.1-5.1.7-10.3 3-15.9 3.4-1 .1-2.2-.2-3.1-.1-2.5.1-4.7 1.3-7.5.9-.8.6-2 1.1-3.2 1-.5.3-.8.5-1.3.8h-13.3c-.2 0-.5-.1-.6-.1-.1.1-.2.1-.3.1h-16.2s0-.1-.1-.1c-1.8-.4-3.3 0-5.2-.4-1.3-.2-2.6-1.2-4-1.1-1 .1-1.7.9-2.5 1.1-1 .2-2.7-.2-4-.1-3.7.1-6.3.3-10-.4-.8-.7.6-.7.5-1.4-2.2-.6-5.7-.3-7.8 0-.8-.2-1.3-.5-2-.6-2.8-.3-7.3 1-9.8 1.1-2.3.1-4-.8-6.5-.6-2-3-6.8 1.8-10-.2-.1-.6.5-.8.7-1.3-3.6.4-6.7 1.7-10 1.3-2.8.6-5.2 1.8-7.7 2-1 .1-3 .4-4.2.3-1-.1-1.7-1-2.9-1.3-.7-.1-1.2.1-1.7 0-.7-.2-1-.7-1.8-.8s-2 .3-3 .4c-2.6.6-4.8 1.5-7.4 2h-2.4c-2.1-1-4.2-2.6-7-2.6-1.8 0-3.5.8-5.7.8-2.8-1.9-5.5-3.7-10.4-2.9-1 .1-1.7.8-2.5.9-2 .4-4.6.4-6.7.3-2.4-.1-4.5-.1-7.1-.3-.7.3-.9.8-1.8.8-1.2-.8-3.6-.5-3.5-2.2-2-.1-3.2-.9-5.7-.6-2.5 1.4-4.5 3.1-9.2 2.9-1.2 1.4-4.2 1.2-5.7.2-.7.3-.7 1-1.5 1.1-.8-.3-1.8-.4-2.7-.6 0 .7-1.1.7-1.8 1.1-.5.3-1.3.8-2 1.3h-5-.2-8.3c-2.5-1.5-5.2-1.5-8.7-1.6-.5.5-1 .9-1.7 1.3-3.6-.6-5.5-3.4-9.7-2.7-1.8 1.1-3.8 2.3-6.2 3h-16.1c-1.3-.4-2.7-.6-4.3-.5-.8 0-1.5.3-2 .5h-2.1c-2-.6-2.9-3-4.8-3.3-1.3-.2-1.7.8-3.1 1-3 .6-6.7.3-7.3-1-1.8.2-2.6-.4-4.2-.3-1.8 1-3.2 2.8-5.2 3.6h-5.7c-.7-.1-1.4-.1-2.1 0h-6.9c-3-.7-5.8-1.6-8.2-.6-.1.3-.2.5-.3.6h-7c-.5-.3-1.1-.5-2-.6-.3.3-.6.5-.9.6h-7.6c-.4-.3-.6-.6-.9-.9-2.5-.1-3.2-.8-5.9-.9-1.2.4-1.4 1.4-2.1 1.9h-2c-.5-.2-1-.5-1.5-.6-1.8-.7-3.2-.8-4-1.6-1.8.5-3.4 1.1-5.6 1.4-3.6.4-8-.1-11 .8h-2.2c-.5-.1-1-.1-1.5-.1-3.1-.3-5 .2-5.6-1.7-3.3-.5-6.5.9-9.6.5-.7.2-1 .6-1.9.8-2.2-1.2-4.9-.3-7.3-.3-3.3-.1-4.8-2.2-7.3-2.3-.3.2-.3.7-1 .6-2.5-.5-4.4.6-6.5.5-1.9-.2-2.8-1.3-4.5-1.9-3.3-.1-7.5-.1-10.5-.5-2-.3-4.4-1.4-5.6-1.5-1-.1-2.5 0-3.4.1-5.1.7-10.4 3-15.9 3.5-1 0-2.1-.2-3.1-.2-2.5.2-4.7 1.3-7.5.9-.9.5-2 1.1-3.1.9-.5.3-.8.6-1.3.8h-13.4c-.2-.1-.5-.1-.6-.2-.1.1-.1.1-.3.2h-16.1c0-.1 0-.1-.1-.2-1.8-.4-3.4 0-5.2-.3-1.3-.2-2.6-1.2-4-1.1-1 .1-1.6.9-2.5 1.1-1 .2-2.6-.2-4-.2-3.6.1-6.3.3-10-.4-.8-.6.6-.7.5-1.4-2.2-.6-5.7-.3-7.8 0-.8-.2-1.3-.6-2-.6-2.8-.3-7.3 1-9.8 1.1-2.3 0-4-.9-6.5-.6-2-3-6.9 1.9-10-.2-.1-.6.5-.8.6-1.3-3.6.4-6.7 1.7-10 1.3-2.9.6-5.1 1.8-7.7 2.1-1 .1-3 .4-4.2.3-.9 0-1.6-1-2.9-1.3-.6-.1-1.2.1-1.6 0-.7-.2-1.1-.7-1.9-.8s-2.1.3-2.9.5c-2.6.5-4.8 1.5-7.4 2h-2.4c-2.1-1-4.1-2.6-7.1-2.7-1.9 0-3.5.8-5.6.8-2.8-1.9-5.4-3.7-10.4-2.9-.9.1-1.6.8-2.5.9-1.9.4-4.6.4-6.7.3-2.4-.1-4.6-.1-7.1-.3-.7.3-.9.8-1.9.8-1.1-.8-3.6-.5-3.6-2.2-2.1-.1-3.2-.9-5.6-.6-2.4 1.5-4.6 3.1-9.2 3-1.1 1.3-4.2 1.2-5.6.1-.7.3-.6 1-1.4 1.1-.9-.3-1.9-.4-2.7-.6.1.7-1.1.7-1.9 1.1-.6.3-1.3.8-2.1 1.3h-5.1c-.1 0-.1 0-.2 0h-8.3c-2.4-1.6-5.2-1.5-8.6-1.6-.4.5-1 .9-1.6 1.3-3.6-.6-5.5-3.4-9.6-2.6-1.8 1.1-3.8 2.3-6.2 2.9h-16.4c-1.3-.4-2.7-.6-4.3-.5-.8.1-1.4.3-2.1.5h-2.1c-2-.6-2.9-3-4.8-3.3-1.3-.2-1.7.8-3.1 1.1-2.9.6-6.7.3-7.3-1.1-1.8.2-2.6-.4-4.2-.3-1.8 1-3.2 2.8-5.2 3.6h-5.7c-.7-.1-1.4-.1-2.1 0h-.1-6.5c-3-.7-5.8-1.6-8.2-.7-.1.3-.2.5-.3.7h-7c-.5-.3-1.2-.6-2-.7-.3.3-.6.5-.9.7h-7.7c-.3-.3-.7-.6-.8-1-2.5 0-3.2-.8-5.9-.9-1.2.4-1.4 1.4-2.1 1.9h-2c-.5-.2-1-.5-1.5-.6-1.8-.7-3.2-.8-4-1.6-1.8.5-3.4 1.2-5.6 1.4-3.6.4-8-.2-10.9.8h-1.6v.8-.1h960v-.9h-28.9z"></path>
        </svg>
      </div>

      <div className="footer-content">
        <div className="footer-top">
          <div className="footer-column">
            <h2>Quick Links</h2>
            <ul>
              <li><Link to="/privacy">Privacy Policy</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h2>Company</h2>
            <ul>
              <li><Link to="/">Shop</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-column footer-contact">
            <div className="email-contact">
              <i className="fa fa-mail-forward email-icon"></i>
              <div className="email-text">
                <h3>
                  <a href="mailto:info@wtf-wear.com">Got A Question? Email us 24/7</a>
                </h3>
                <p><a href="mailto:info@wtf-wear.com">Info@wtf-wear.com</a></p>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-middle">
          <div className="footer-logo-section">
            <img src="/images/wtf_wear_trans.png" title="wtf_wear" alt="wtf_wear" loading="lazy" className="footer-logo" />
            <div className="social-icons">
              <a href="https://www.instagram.com/wtfwear1981/" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://m.facebook.com/wtfwearcom/" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://m.youtube.com/channel/UCZHFSZr40J4gehrkJOplYzQ/featured" aria-label="YouTube" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-youtube"></i>
              </a>
              <a href="https://www.tiktok.com/@wtfwear" aria-label="TikTok" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-tiktok"></i>
              </a>
              <a href="https://x.com/wtfwear81" aria-label="X (Twitter)" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-x-twitter"></i>
              </a>
              <a href="https://www.threads.com/@wtfwear1981" aria-label="Threads" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-threads"></i>
              </a>
            </div>
          </div>

          <div className="newsletter-section">
            <h2>Sign up for newsletter</h2>
            <form className="newsletter-form" onSubmit={handleSubscribe}>
              <input
                type="email"
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={submitting}
                required
              />
              <button type="submit" disabled={submitting}>
                {submitting ? 'Subscribing...' : 'Subcribe'}
              </button>
            </form>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="copyright">Copyright © 2025 wtf-wear. All Rights Reserved.</p>
          <div className="payment-methods">
            <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='24' viewBox='0 0 40 24'%3E%3Crect fill='%23fff' width='40' height='24' rx='3'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='Arial' font-size='10' font-weight='bold' fill='%231A1F71'%3EVISA%3C/text%3E%3C/svg%3E" alt="VISA" className="payment-card-img" />
            <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='24' viewBox='0 0 40 24'%3E%3Crect fill='%23000' width='40' height='24' rx='3'/%3E%3Ccircle cx='15' cy='12' r='7' fill='%23EB001B'/%3E%3Ccircle cx='25' cy='12' r='7' fill='%23FF5F00'/%3E%3C/svg%3E" alt="MASTERCARD" className="payment-card-img" />
            <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='24' viewBox='0 0 40 24'%3E%3Crect fill='%23003087' width='40' height='24' rx='3'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='Arial' font-size='8' font-weight='bold' fill='%23fff'%3EPayPal%3C/text%3E%3C/svg%3E" alt="PAYPAL" className="payment-card-img" />
            <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='24' viewBox='0 0 40 24'%3E%3Crect fill='%23006FCF' width='40' height='24' rx='3'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='Arial' font-size='8' font-weight='bold' fill='%23fff'%3EAMEX%3C/text%3E%3C/svg%3E" alt="AMEX" className="payment-card-img" />
            <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='24' viewBox='0 0 40 24'%3E%3Crect fill='%23FF6000' width='40' height='24' rx='3'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='Arial' font-size='7' font-weight='bold' fill='%23000'%3EDISCOVER%3C/text%3E%3C/svg%3E" alt="DISCOVER" className="payment-card-img" />
          </div>
        </div>

        <div className="footer-credits">
          <p>Powered by <span className="company-name">CJB Software LLC</span></p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
